import { useTranslation } from "react-i18next";

const CartBox = ({cartItemsData}) => {
    const { t } = useTranslation();
    const formatter = new Intl.NumberFormat('de-DE', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });

    return (
        <div className="flex divide-x-2 divide-gray-dark1 divide-dashed h-12 sm:h-20 justify-end text-xs md:text-sm lg:text-base"> 
            <div></div>
            <div className="px-1.5 lg:px-5 space-y-2 md:space-y-3">
                <h1 className="capitalize font-semibold text-light-400">{ t('no. of items')}</h1>
                <div className="font-bold">{cartItemsData.itemsCount}</div>
            </div>
            <div className="px-1.5 lg:px-5 space-y-2 md:space-y-3">
                <h1 className="capitalize font-semibold text-light-400">{ t('total quantity')}</h1>
                <div className="font-bold">{cartItemsData.totalQuantity ? formatter.format(cartItemsData.totalQuantity) : formatter.format(0)}</div>
            </div>
            {/* <div className="px-1.5 lg:px-5 space-y-2 md:space-y-3">
                <h1 className="capitalize font-semibold text-light-400">{ t('total points')}</h1>
                <div className="font-bold">{cartItemsData.totalPoints ? cartItemsData.totalPoints : 0}</div>
            </div> */}
            <div className="px-1.5 lg:px-5 space-y-2 md:space-y-3">
                <h1 className="capitalize font-semibold text-light-400">{ t('initial price')}</h1>
                <div className="font-bold">{cartItemsData.totalInitialPrice ? formatter.format(cartItemsData.totalInitialPrice) : formatter.format(0)} €</div>
            </div>
        </div> 
    )
}

export default CartBox;